// extracted by mini-css-extract-plugin
var _1 = "checkbox-container--M0W07";
var _2 = "checkbox-disabled--_21A3";
var _3 = "checkbox-icon-container--rpnnB";
var _4 = "custom-checkbox--C3S4p";
export { _1 as "checkbox-container", _2 as "checkbox-disabled", _3 as "checkbox-icon-container", _4 as "custom-checkbox" }
